import { FC } from 'react';
import ReserveDateList from './ReserveDateList';
import UseReserveDateList from './UseReserveDateList';

const ReserveScheduleContainer: FC = () => {
  return <ReserveDateList {...UseReserveDateList()} />;
};

export default ReserveScheduleContainer;
